import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAwardSummary } from '../redux/actions';
import AwardChapter from './AwardChapter';
import AwardCategory  from './AwardCategory';
import AwardItem from './AwardItem';
import { chapterSelector, awardCategorySelector, awardSelector } from "../redux/selectors";
import { toArray } from "../common/util";


class AwardsSummary extends Component {
    componentDidMount() {
        this.props.getAwards();
        document.title = "Addiction | Award List"
    }
    render() {

        const awardSummary = toArray(this.props.chapters)
            .filter(chapter => toArray(this.props.awardCategories.data).filter(category => category.chapter === chapter.id).length > 0) // Remove chapters which have no award categories
            .map((item) => (
            <AwardChapter key={`${item.id}-awardchapter`} chapter={item}>
            {
                toArray(this.props.awardCategories.data)
                    .filter(category => category.chapter === item.id)
                    .sort((a, b) => a.order - b.order)
                    .map((category) => (
                        <AwardCategory key={category.id} category={category}>
                        { category.awards ?
                            category.awards.map((award) => (
                                <AwardItem key={award} award={this.props.awards[award]}/>
                            )) : ('')
                        }
                        </AwardCategory>
                    ))
            }
            </AwardChapter>
        ));
        return (
            <div>
                <h1>Awards</h1>
                {awardSummary}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
    awardCategories: awardCategorySelector(state),
    awards: awardSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getAwards: () => dispatch(fetchAwardSummary()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardsSummary);


// WEBPACK FOOTER //
// ./src/Awards/AwardsSummary.js